import { Component } from "react";

import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export enum LinkedScheduleItemStatus {
    Unknown = 0,
    NotStarted = 1,
    NotCompleted = 2,
    Completed = 3,
}

export const LinkedScheduleItemStatusDescription = new Map<LinkedScheduleItemStatus, string>([
    [LinkedScheduleItemStatus.Unknown, ""],
    [LinkedScheduleItemStatus.NotStarted, "Not Started"],
    [LinkedScheduleItemStatus.NotCompleted, "Not Completed"],
    [LinkedScheduleItemStatus.Completed, "Completed"],
]);

export const LinkedScheduleItemStatusType = (status: LinkedScheduleItemStatus) => {
    switch (status) {
        case LinkedScheduleItemStatus.NotCompleted:
            return "pending";
        case LinkedScheduleItemStatus.Completed:
            return "success";
        default:
            return "";
    }
};

interface ILinkedScheduleItemStatusTagProps {
    status: LinkedScheduleItemStatus;
}

export class LinkedScheduleItemStatusTag extends Component<ILinkedScheduleItemStatusTagProps> {
    render() {
        const { status } = this.props;
        if (status === LinkedScheduleItemStatus.Unknown) {
            return null;
        }
        return (
            <StatusTagDisplay
                statusText={LinkedScheduleItemStatusDescription.get(status)}
                statusType={LinkedScheduleItemStatusType(status)}
            />
        );
    }
}
